import { Box, Flex } from "@chakra-ui/react";
import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeHighlight from "rehype-highlight"
import math from'remark-math'
import katex from 'rehype-katex'
// import 'katex/dist/katex.min.css';
// import "highlight.js/styles/atom-one-dark.css";
import remarkGfm from 'remark-gfm';
import { contentFormat } from "./plugins/content";
import rehypeRaw from 'rehype-raw'

const formatLatex = (markdown: string) => {
  return markdown
    .replace(/\\\[/g, '$$') // 开始的 \[ 替换为 $$
    .replace(/\\\]/g, '$$') // 结束的 \] 替换为 $$
    .replace(/\\\{/g, '$$') // 处理 \{ 等转义符号
    .replace(/\\\}/g, '$$')
    .replace(/\\\(/g, "$")
    .replace(/\\\)/g, "$");
}

const Markdown = ({ useBlink=false, content , children = null, ...styles }) => {


  return (
    <Box {...styles} css={{ "& ul li, & ol li": {
      "marginLeft": "2em",
    }, "& code": { whiteSpace: "pre-wrap" }, "& pre": { wordBreak: "break-word" }, "& a": { wordBreak: "break-word" }}}>
      <ReactMarkdown   remarkPlugins={[remarkGfm, math ]} rehypePlugins={[rehypeHighlight, contentFormat, rehypeRaw, katex]}>
        {formatLatex(content)}
      </ReactMarkdown>
      {children}
    </Box>
  );
};

export default Markdown;